// frontend/src/components/HomePageHeaderWrapper.jsx
// Wrapper component to provide HomePageHeaderContext at App level
// This allows Header (rendered in App.jsx) to access the context

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HomePageHeaderProvider } from "../contexts/HomePageHeaderContext.jsx";

const HomePageHeaderWrapper = ({ children }) => {
  const location = useLocation();
  const [contextValue, setContextValue] = useState(null);

  // Listen for context updates from HomePage
  useEffect(() => {
    const handleContextUpdate = (event) => {
      if (event.detail && typeof event.detail === 'object') {
        setContextValue(event.detail);
      }
    };

    window.addEventListener('homePageHeaderContextUpdate', handleContextUpdate);
    return () => {
      window.removeEventListener('homePageHeaderContextUpdate', handleContextUpdate);
    };
  }, []);

  // Clear context when navigating away from homepage
  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "") {
      setContextValue(null);
    }
  }, [location.pathname]);

  return (
    <HomePageHeaderProvider value={contextValue}>
      {children}
    </HomePageHeaderProvider>
  );
};

export default HomePageHeaderWrapper;

